import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function SettingsAlt2({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M20.9999 7H17.9399M12.94 7H3M17.2101 5.22998C18.1801 6.19998 18.1801 7.77999 17.2101 8.75999C16.2301 9.72999 14.6501 9.72999 13.6701 8.75999C12.6901 7.77999 12.6901 6.19999 13.6701 5.21999C14.6401 4.23999 16.2201 4.23999 17.2001 5.21999M11.0601 17H21.0001M3 17H6.06M10.3199 15.245C11.2899 16.215 11.2899 17.795 10.3199 18.775C9.33992 19.745 7.75992 19.745 6.77992 18.775C5.79992 17.795 5.79992 16.215 6.77992 15.235C7.74992 14.255 9.32992 14.255 10.3099 15.235" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default SettingsAlt2;